import React from 'react';
import { browserHistory, Link } from 'react-router';
import axios from 'axios';

import Form from '../../../Form/Form/';
import Spinner from '../../../Spinner';

import './Signin.scss';

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentValues: {},
      error: null,
      loading: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleAuthentication = this.handleAuthentication.bind(this);
    this.handleOnKey = this.handleOnKey.bind(this);
  }

  handleChange(event) {
    this.setState({
      currentValues: event.target.value,
      error: null,
    });
  }

  handleOnKey(event) {
    switch (event.keyCode) {
      case 13: // Enter
        event.preventDefault();
        this.handleAuthentication();
        break;
    }
  }

  handleAuthentication() {
    const FormData = this.state.currentValues;
    const validateInput = (form, input) => !(Object.prototype.hasOwnProperty.call(form, input) && form[input] !== '');

    if (validateInput(FormData, 'email')) {
      this.setState({
        error: 'Please enter your email',
      });
      return;
    }

    if (validateInput(FormData, 'password')) {
      this.setState({
        error: 'Please enter your password',
      });
      return;
    }

    this.setState({
      loading: true,
    });

    axios.post(__AuthLink, { // eslint-disable-line no-undef
      email: FormData.email,
      password: FormData.password,
    }).then(response => {
      this.props.authenticateUser(response.data.token);
      this.setState({
        loading: false,
      });
      location.reload();
    }).catch(err => {
      console.log('Error: ', err);
      this.setState({
        error: err.response.data.error,
        loading: false,
      });
    });
  }

  GetSSOLinkedIN() {
    const Origin = encodeURI(window.location.origin);
    const Redirect = encodeURI(window.location.pathname.substring(1));

    return "https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=78al7m56tam7os&redirect_uri=" + Origin + "%2Fsignin%2Fauth%2Flinkedin&state=" + Redirect + "&scope=r_basicprofile,r_emailaddress"
  }

  render() {
    const getSigninError = ErrCode => {
      switch (ErrCode) {
        case 'Linkedin':
          return "Your account does not exist. Your LinkedIn account's email address may not match the email address you used to register with Paragon One. Please signin with your email and password instead, and you can update your email on file if you wish to signin with LinkedIn in the future. If you can't remember your password, just use the \"forgot password\" functionality below."
          break;
        default:
          return "An error occured while signing you in."
          break;
      }
    }
    return (
      <div className='SignIn__Wrapper'>
        {this.props.location.query.SigninErr && (
          <p className='errorText' style={{ textAlign: 'center' }}>{getSigninError(this.props.location.query.SigninErr)}</p>
        )}
        <h2 className='FormSegment__title' style={{ textAlign: 'center', marginBottom: '40px' }} >Sign into your account</h2>
        <a className='LinkedinSSO' href={this.GetSSOLinkedIN()}></a>
        <br />
        <br />
        <h5 style={{ textAlign: 'center', margin: '30px 0' }}>Or sign in with email:</h5>
        {(this.state.error !== null) ? <p className='errorText'>{this.state.error}</p> : null}
        <Form onChange={this.handleChange}>
          <div className='row'>
            <div className='col-md'>
              <input type='text' placeholder='Email' onKeyDown={this.handleOnKey} className='Form__Input' name='email' />
            </div>
          </div>
          <div className='row'>
            <div className='col-md'>
              <input type='password' placeholder='Password' onKeyDown={this.handleOnKey} className='Form__Input' name='password' />
            </div>
          </div>
        </Form>
        <span onClick={this.handleAuthentication} className='ButtonEmail__Submit'>
          {(this.state.loading) ? <Spinner className='spinner--white' /> : 'Login'}
        </span>
        <br />
        <Link style={{ textAlign: 'center', display: 'block' }} to='/user/forgot-password'>Forgot your password?</Link>
      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/components/LoginHOC/components/Login/index.js